'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import FaAngleDoubleDown from 'react-icons/lib/fa/angle-double-down';

class Hero extends React.Component {

  componentDidMount() {
    // var $this = ReactDOM.findDOMNode(this);
    // //console.log($this)
    // $this.findElementById('hero-carousel').carousel()
  }
  render() {
    return (
      <section className='hero-component' id='inicio'>
        <div id='hero-carousel' className='carousel slide' data-ride='carousel'>
          <ol className='carousel-indicators'>
            <li data-target='#hero-carousel' data-slide-to='0' className='active'></li>
            <li data-target='#hero-carousel' data-slide-to='1'></li>
            <li data-target='#hero-carousel' data-slide-to='2'></li>
            <li data-target='#hero-carousel' data-slide-to='3'></li>
            <li data-target='#hero-carousel' data-slide-to='4'></li>
          </ol>
          <div className='carousel-inner'>
            <div className='carousel-item active'>
              <div style={{
                background: 'url(/static/images/carousel/1.jpeg)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
                width: '100vw',
                height: '100vh'
              }}></div>
            </div>
            <div className='carousel-item'>
            <div style={{
                background: 'url(/static/images/carousel/2.jpeg)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
                width: '100vw',
                height: '100vh'
              }}></div>              {/* <img className='' src='/static/images/carousel/2.jpeg' alt='Detalhe Jante' /> */}
            </div>
            <div className='carousel-item'>
            <div style={{
                background: 'url(/static/images/carousel/3.jpeg)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
                width: '100vw',
                height: '100vh'
              }}></div>              {/* <img className='' src='/static/images/carousel/3.jpeg' alt='Detalhe Logo Chemical Guys 1/1' /> */}
            </div>
            <div className='carousel-item'>
            <div style={{
                background: 'url(/static/images/carousel/4.jpeg)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
                width: '100vw',
                height: '100vh'
              }}></div>              {/* <img className='' src='/static/images/carousel/4.jpeg' alt='Detalhe Logo Chemical Guys 3/2' /> */}
            </div>
            <div className='carousel-item'>
            <div style={{
                background: 'url(/static/images/carousel/5.jpeg)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
                width: '100vw',
                height: '100vh'
              }}></div>              {/* <img className='' src='/static/images/carousel/5.jpeg' alt='Carro com paisagem' /> */}
            </div>
          </div>
          {/* <a className='carousel-control-prev' href='#hero-carousel' role='button' data-slide='prev'>
          <span className='carousel-control-prev-icon' aria-hidden='true'></span>
          <span className='sr-only'>Previous</span>
        </a>
        <a className='carousel-control-next' href='#hero-carousel' role='button' data-slide='next'>
          <span className='carousel-control-next-icon' aria-hidden='true'></span>
          <span className='sr-only'>Next</span>
        </a> */}
        </div>
      </section>
    );
  }

}

Hero.displayName = 'Hero';

// Uncomment properties you need
// Footer.propTypes = {};
// Footer.defaultProps = {};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.js